import MapViewer from "./MapViewer";
import {fullPageMap} from "./mapHelpers";

window.addEventListener('load', function(){

    let full_map = $('#full_map').first();

    if(full_map.length > 0){

        let opts = {
            zoomControl: false,
            showMenu: false
        }
        let coordinates = full_map.data('coordinates');
        if(coordinates){
            coordinates = coordinates.split(",");
            opts.coordinates = {lat: Number.parseFloat(coordinates[0]), lng: Number.parseFloat(coordinates[1])}
        }

        let map = new MapViewer(opts);
        map.initMap();
        let container = map.getMapContainer();
        full_map.html(container);
        fullPageMap(map);
    }

})